import React, { Component } from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

import Logger, {LOG_LEVELS} from '../../utils/logger';
const log = new Logger('APPROVE_FILING', LOG_LEVELS.DEBUG);

class ApproveFiling extends Component {

  render() {
    log.debug('render(): ', this.props);
    return (
      <ReadOnlyWrapper>
        <div data-testid="approve-filing">
            <button className="primary float-left margin-bottom-md margin-right-md" onClick={this.props.onApprove}><LanguageStringResolver string='filingPage_ApproveAndDownloadBtn' /></button>
        </div>
      </ReadOnlyWrapper>
    );
  }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  return {}
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(ApproveFiling);
